import { createFileRoute } from '@tanstack/react-router'
import { requireActiveSubscription, requireRoles } from '@/lib/middleware'
import { REGISTER_VIEW_ROLES } from '@/features/medication-register/access'
import { RegisterAccountPage } from '@/features/medication-register/account-page'

/** One register's balance and ledger — readable even once closed (R7). */
export const Route = createFileRoute(
  '/_authenticated/_organization/compliance/drugs-register/$accountId/'
)({
  beforeLoad: async () => {
    await requireRoles([...REGISTER_VIEW_ROLES])
    await requireActiveSubscription()
  },
  component: RegisterAccountPage,
})
